import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { StyledRadioWrapper, StyledRadioInput, StyledLabel } from "../../../../admin/searchPaymentPlan/PlanActions/PlanActionsRadioGroup/PlanActionsRadio/PlanActionsRadio.styled";
import CreditCardChoice from './CreditCardChoice/CardChoice';
import { StyledCreditCardChoiceModal } from './CreditCardChoice.styled';
import BllinkTime from '../../../common/utils/time';

const CreditCardChoiceModal = ({ show, onHide, creditCardsData, onContinueClick, currentRadio, onRadioChange, buildingId, apartmentNumber }) => {
    const { t } = useTranslation();
    const [radioSelected, setRadioSelected] = useState('newCard');
    const [radiosDisabled, setRadiosDisabled] = useState(true);
    const [futureChargeDate, setFutureChargeDate] = useState('');

    const onRadioSelect = value => setRadioSelected(value);

    useEffect(() => {
        const cacheOptions = {buildingID: buildingId, apartmentNumber: apartmentNumber};
        const date = BllinkTime.getFutureChargeDate(cacheOptions);
        setFutureChargeDate(date);
    }, [buildingId, apartmentNumber]);

    useEffect(() => {
        if (radioSelected === 'existingCard') setRadiosDisabled(false);
        else setRadiosDisabled(true);
    }, [radioSelected])

    return (
        <StyledCreditCardChoiceModal
            show={show}
            onHide={onHide}
            centered
        >
            <Modal.Header>
                <Modal.Title>{t('creditCardChoice.headers.selectCard')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="info-text">
                    <div>{t('creditCardChoice.infoText.paidInThePast')}</div>
                    <div>{t('creditCardChoice.infoText.shorterProcess')}</div>
                </div>

                <StyledRadioWrapper>
                    <StyledRadioInput
                        className="form-check-input"
                        type="radio"
                        name="paymentChoice"
                        value="newCard"
                        id="newCard"
                        checked={radioSelected === "newCard"}
                        onChange={e => onRadioSelect(e.target.value)}
                    />
                    <StyledLabel className={`form-check-label`} htmlFor="newCard">{t('creditCardChoice.checkboxLabels.newCard')}</StyledLabel>
                </StyledRadioWrapper>

                <OverlayTrigger
                    placement="top"
                    overlay={props => (
                        <Tooltip {...props}>
                            {!!futureChargeDate && t('creditCardChoice.infoText.disabledExistingChoice')}
                        </Tooltip>
                    )}
                >
                    <StyledRadioWrapper>
                        <StyledRadioInput
                            className="form-check-input"
                            type="radio"
                            name="paymentChoice"
                            value="existingCard"
                            id="existingCard"
                            checked={radioSelected === "existingCard"}
                            onChange={e => onRadioSelect(e.target.value)}
                            disabled={!!futureChargeDate}
                        />
                        <StyledLabel className={`form-check-label`} htmlFor="existingCard">{t('creditCardChoice.checkboxLabels.existingCard')}</StyledLabel>
                    </StyledRadioWrapper>
                </OverlayTrigger>
              
                <CreditCardChoice 
                    radioArr={creditCardsData} 
                    disabled={radiosDisabled} 
                    current={currentRadio}
                    onRadioChange={onRadioChange}
                />

                <button
                    className="bllink-button"
                    onClick={() => onContinueClick(radioSelected)}
                >
                    {t('creditCardChoice.btns.continue')}
                </button>
            </Modal.Body>
        </StyledCreditCardChoiceModal>
    );
};

export default CreditCardChoiceModal;